export default {
    infoAboutService: 'Information about the service',
    infoAboutParkingArea: 'Parking area address',

    openingHours: 'Opening hours',
    openingHoursWeek: 'Mo - Fr',
    openingHoursSaturday: 'Sa',
    openingHoursSunday: 'Su',
    openingHoursNote: 'Please check the current opening hours on the service website.',

    contact: 'Contact',
    contactEmail: 'E-mail',
    contactPhone: 'Telephone',
    operator: 'Operator',

    infoAboutChargingStation: 'Information about charging station',
    imageSource: 'Source',
    buttonCopyAddress: 'Copy address',
    buttonCopyGps: 'Copy GPS',
    tooltipCopied: 'Copied',
    recommendedCard: 'Recommended card',
    recommendedCardProviderInfo: 'and their acceptance network',
    recommendedCardProviderInfoUpTo: 'up to',
    recommendedCardProviderInfoHigherPower: 'higher power',
    recommendedCardModalTitle: 'Recommended charging card',
    recommendedCardModalDescription: 'Drivers of Drivalia vehicles receive two cards to ensure the widest possible coverage, as well as competitive pricing. In the station preview we will advise you which card is the most advantageous to use.<br /><br />The name of the card can be found in the top left corner of the card.',
    stationIdentification: 'Station ID',
    stationUnderConstruction: 'You can look forward to this station, it is under construction.',
    stationAdditionalInformation: 'In case of charging fault please call the phone number stated at the charging station. In other cases you can call our driver hotline <a href="tel:+420296333666">+420 296 333 666</a>.',

    connectors: 'Connectors',

    additionalServices: 'Supplementary services',
    additionalServicesFree: 'free',
    additionalServicesNotAgreed: 'service is not agreed',
    additionalServicesPickUp: 'Pick-Up',
    additionalServicesReplacementVehicle: 'Replacement vehicle',
    additionalServicesCarWash: 'Car wash - exterior',

    additionalServicesPickupNote: 'The pick-up service is only available up to the distance of 20 km.',
    additionalServicesReplacementVehicleNote: 'Replacement vehicle is free of charge for the duration of the service, but for a maximum of 1 day.',
    additionalServicesCarWashNote: 'The free washing service includes only basic exterior washing and interior vacuuming.',
    additionalServicesChargeNote: 'The service will be charged unless stated otherwise.',

    orderToServiceButton: 'Make appointment with the service location',
    orderReturnWithInspector: 'Make appointment with an inspector',
    navigateToServiceButton: 'Navigate to the service location',
    navigateToChargingStationButton: 'Navigate to the charging station',

    errorMessageNotFound: 'Service not found.',
    errorMessageChargingStationNotFound: 'Charging station not found.'
}
